function getLocalStorage(key: string) {
  try {
    const data = localStorage.getItem(key);
    if (data) {
      return JSON.parse(data);
    }
    return data;
  } catch (err) {
    return undefined;
  }
}

function setLocalStorage(key: string, data: any) {
  localStorage.setItem(key, JSON.stringify(data));
}

function removeLocalStorage(key: string) {
  localStorage.removeItem(key);
}

function clearData() {
  localStorage.clear();
}

export {
  getLocalStorage,
  setLocalStorage,
  clearData,
  removeLocalStorage,
};
